// removed by extract-text-webpack-plugin
module.exports = {"flex":"Home__flex___1KJ0p","flex-column":"Home__flex-column___3omZM","flex-column-center":"Home__flex-column-center___3BFEB","container":"Home__container___7V2KV","section":"Home__section___221nT","flex-row":"Home__flex-row___Eul3_","flex-row-center":"Home__flex-row-center___25bj7"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/components/Home/Home.scss
// module id = 1752
// module chunks = 7